






















import Vue from 'vue';
import ActionButton from '@/components/common/ActionButton.vue';
import DeviceType from '@/enums/DeviceType';

export default Vue.extend({
  name: 'EnterPassword',
  components: {
    ActionButton,
  },
  data() {
    return {
      password: '',
    };
  },
  computed: {
    ssid(): string {
      return this.$store.state.registrationData.ssid;
    },
    selectWiFiDescription(): string {
      switch (this.$store.state.deviceType) {
        case DeviceType.Light:
          return Vue.i18n.translate('Select_Wifi_Description_Light') || '';
        case DeviceType.Plug:
          return Vue.i18n.translate('Select_Wifi_Description_Plug') || '';
        case DeviceType.WiFiSwitch:
          return (
            Vue.i18n.translate('Select_Wifi_Description_WiFi_Switch') || ''
          );
      }
      return '';
    },
  },
  methods: {
    submitCredentials() {
      console.log('Submitting');
      this.$store.commit('updatePassword', this.password);
      this.$store.commit('updatePairingStatus', {
        type: 'encryptingCredentials',
        ssidNotFound: false,
        passwordIsWrong: false,
        ssidList: [],
      });
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EnterPassword.vue